export default import.meta.ROLLUP_FILE_URL_1XgU9to4;